import firebase from "firebase/app";
import "firebase/firestore";
import flamelink from "flamelink/app";
import "flamelink/content";
import "flamelink/storage";
import { isFileImage } from './imageUtil.js'
import { isFileMp4 } from './imageUtil.js'
import moment from 'moment'


const firebaseConfig = {
  apiKey: "AIzaSyBIVuXjjq7esIyBQON4x0lOkOOtdldAlYI",
  authDomain: "nike-7896-site-art-collab.firebaseapp.com",
  projectId: "nike-7896-site-art-collab",
  storageBucket: "nike-7896-site-art-collab.appspot.com",
  messagingSenderId: "721079919043",
  appId: "1:721079919043:web:45f1966a3de4bfee39dd76",
  measurementId: "G-PNQ1XM1CT6",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const flamelinkApp = flamelink({
  firebaseApp,
  env: "production",
  locale: "en-US",
  dbType: "cf",
});

// {
//   weekNumber: string;
//   challengeTitle: string;
//   challengeDescription: string;
// }

export const getFlamelinkChallenges = () => {
  return flamelinkApp.content.get({
    schemaKey: "challenges",
    populate: true,
  });
};

export const getFlamelinkWeeks = () => {
  return flamelinkApp.content.get({
    schemaKey: "weeks",
    populate: true,
  });
}

export const getFlameLinkReadingMaterials = () => {
  return flamelinkApp.content.get({
    schemaKey: "contentLinkWithImage",
    populate: true,
  })
}
// {
//   name: string;
//   location: string;
//   igLink: string;
//   image: file
// }


export async function getFlamelinkWearTesters(phaseNumber) {
  const data = await flamelinkApp.content.get({
    schemaKey: "wearTester",
    populate: true
  })

  let testers = Object.keys(data).map(key => {

    let wearTester = data[key]
    let imageUrl = ''

    if (wearTester.badgeImage != null && wearTester.badgeImage.length != 0) {
      imageUrl = wearTester.badgeImage[0].url;
    } else {
      imageUrl = wearTester.fallbackBadgeImageUrl;
    }

    return { ...wearTester, uid: key, fallbackBadgeImageUrl: imageUrl }
  });

  testers = testers.filter(tester => tester.location != 'nike')

  if (phaseNumber == 1) {
    return testers.filter(t => t.phase != 'PHASE2');
  }

  if(phaseNumber == 2) {
    return testers.filter(t => t.phase == 'PHASE2');
  }

  return testers;

};

export const getFlamelinkWearTesterByPassword = (loginCode) => {
  return flamelinkApp.content.getByField({
    schemaKey: "logins",
    field: "password",
    value: loginCode,
  });
};

export async function uploadImageOrVideo(file, onProgressUpdated) {
  let isImage = isFileImage(file)
  let isVideo = isFileMp4(file)

  if (!isImage && !isVideo) {
    alert("Only accept .mp4, .png, .jpg, .gif")
    return false
  }

  var storageRef = firebase.storage().ref();
  var metadata = { contentType: file.type };

  let uploadTask = storageRef.child('uploadedContent/' + file.name).put(file, metadata);

  // state of upload
  uploadTask.on('state_changed', function (snapshot) {
    var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
    onProgressUpdated(progress)
  })

  // on upload complete
  return uploadTask.then(async (snapshot) => {
    let url = await snapshot.ref.getDownloadURL();

    return Promise.resolve(url)
  })
}


export async function uploadSubmission(imageAsFile, userName, challengeId, onProgressUpdated) {

  let fileURL = await uploadImageOrVideo(imageAsFile, onProgressUpdated)
  if (fileURL == false) {
    return;
  }



  flamelinkApp.content.add({
    schemaKey: 'userSubmissions',
    data: {
      submissionId: new Date().getTime() + "",
      userName: userName,
      challengeId: challengeId,
      fileUrl: fileURL,
    },
  }).then(result => {

  }).catch(error => console.error('Error adding entry', error))
}

let chatSubscriptionDisposer = () => { };

export async function onChatMessageRecieved(onTextAdded, weekID) {
  chatSubscriptionDisposer = flamelinkApp.content.subscribe({
    schemaKey: 'wearTester_copy_1', // TODO: CHANGE THIS IN FIRESTORE I HAVE NO TIME ATM
    changeType: 'added',
    // filters: [['challengeId', '==', weekID]], // TODO: This is what we should do, but i cant get switching from one sub to another working in time. 
    callback(error, result) {

      if (result != null) {
        onTextAdded(Object.keys(result).map(key => result[key]))
      }
    }
  })
}

export function unsubscribeToChat() {
  chatSubscriptionDisposer();
}

export function addChatMessage(message, challengeId, username) {
  let timestamp = moment().unix();

  flamelinkApp.content.add({
    schemaKey: 'wearTester_copy_1',
    data: {
      message: message,
      challengeId: 'NO_FILTER_DOESNT_MATTER_ANYMORE', // challengeId,
      unixTime: timestamp,
      username: username,
    },
  })
}

export const getFlamelinkZoomLink = () => {
  return flamelinkApp.content.get({
    schemaKey: "briefingRoomLink",
    populate: true,
  });
};

/*
    "HANDLE": "@__herberth",
    "LINK TO IG HANDLE": "https://www.instagram.com/__herberth/",
    "FIRST": "Aldo",
    "LAST": "André",
    "SCREEN NAME": "A.ANDRÉ",
    "PASSWORD": "profiler-contracting"
}
*/

export const flameLinkUploadUser = (user) => {
  flamelinkApp.content.add({
    schemaKey: "wearTester",
    data: {
      name: user.SCREEN_NAME,
      igLink: user.LINK_TO_IG_HANDLE,
      phase: 'PHASE2',
      isVisible: true
    }
  });
}


export const flamelinkUploadpassword = (user) => {
  console.log(user)
  flamelinkApp.content.add({
    schemaKey: "logins",
    data: {
      email: `N/A`,
      password: user.PASSWORD,
      username: user.SCREEN_NAME,
    }
  });
}